/* global axios */

const waCallsApi = {
  resolveSession(accountId, inboxId) {
    return axios
      .get(`/api/v1/accounts/${accountId}/wacalls/resolve?inbox_id=${inboxId}`)
      .then(r => r.data);
  },

  getSessions(accountId) {
    return axios
      .get(`/api/v1/accounts/${accountId}/wacalls/sessions`)
      .then(r => r.data);
  },

  createSession(accountId, params) {
    return axios
      .post(`/api/v1/accounts/${accountId}/wacalls/sessions`, params)
      .then(r => r.data);
  },

  deleteSession(accountId, sid) {
    return axios
      .delete(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}`)
      .then(r => r.data);
  },

  pairSession(accountId, sid) {
    return axios
      .post(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/pair`)
      .then(r => r.data);
  },

  logoutSession(accountId, sid) {
    return axios
      .post(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/logout`)
      .then(r => r.data);
  },

  getHistory(accountId, sid) {
    return axios
      .get(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/history`)
      .then(r => r.data);
  },

  getChatwootConfig(accountId, sid) {
    return axios
      .get(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/chatwoot`)
      .then(r => r.data);
  },

  autoConfigure(accountId, sid, inboxId) {
    return axios
      .post(
        `/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/auto_configure`,
        { inbox_id: inboxId }
      )
      .then(r => r.data);
  },

  setChatwootConfig(accountId, sid, params) {
    return axios
      .post(
        `/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/chatwoot`,
        params
      )
      .then(r => r.data);
  },

  deleteChatwootConfig(accountId, sid) {
    return axios
      .delete(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/chatwoot`)
      .then(r => r.data);
  },

  setWebhook(accountId, sid, url) {
    return axios
      .post(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/webhook`, {
        url,
      })
      .then(r => r.data);
  },

  listCalls(accountId, sid) {
    return axios
      .get(`/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/calls`)
      .then(r => r.data);
  },

  acceptCall(accountId, sid, callId) {
    return axios
      .post(
        `/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/calls/${callId}/accept`
      )
      .then(r => r.data);
  },

  rejectCall(accountId, sid, callId) {
    return axios
      .post(
        `/api/v1/accounts/${accountId}/wacalls/sessions/${sid}/calls/${callId}/reject`
      )
      .then(r => r.data);
  },
};

export default waCallsApi;
